import React from 'react';
import { useIntl } from 'react-intl';
import { Label } from '@americanexpress/dls-react';
import DropdownButton from '../DropdownButton/DropdownButton';
import { useRoomsContext } from '../../contexts/roomsContext';
import { countTravelersFromRooms } from '../../utils/roomReducerUtil';
import { useConfigContext } from '../../contexts/configContext';
import { bindFunctionValue } from '../../utils/bindFunctionValue';
import DropDownButtonVariant from '../DropdownButton/DropDownButtonVariant';
import { useMosaicContext } from '../../contexts/mosaicContext';

const getInputLabel = ({ inputLabel, hasRooms, formatMessage }) => {
  if (inputLabel) {
    return inputLabel;
  }
  if (hasRooms) {
    return formatMessage({ id: 'room_traveler_label' });
  }
  return formatMessage({ id: 'traveler_label' });
};

const getDropdownLabel = ({
  shouldAppendDropdownLabel, hasRooms, rooms, totalTravelers, formatMessage,
}) => {
  if (shouldAppendDropdownLabel) {
    return formatMessage({
      id: hasRooms ? 'totalTravelersAndRooms' : 'totalTravelers',
    }, { totalRooms: rooms.length, totalTravelers });
  }

  return totalTravelers;
};

const TravelersRoomButton = React.forwardRef((_, ref) => {
  const {
    rooms,
    setTooltipVisible,
    tooltipVisible,
  } = useRoomsContext();
  const {
    element,
    hasLabel,
    hasRooms,
    inputLabel,
    shouldAppendDropdownLabel,
    moduleId,
  } = useConfigContext();
  const { formatMessage } = useIntl();
  const totalTravelers = countTravelersFromRooms(rooms);
  const isMosaicDesign = useMosaicContext();
  const label = hasLabel && !isMosaicDesign ? formatMessage({ id: 'travelersLabel' }) : '';

  const currentValue = getDropdownLabel({
    shouldAppendDropdownLabel,
    hasRooms,
    rooms,
    totalTravelers,
    formatMessage,
  });

  const labelTranslation = getInputLabel({ inputLabel, hasRooms, formatMessage });

  return (
    isMosaicDesign ? (
      <div className="col pad-0">
        <Label id={`${moduleId}_popupButton-label`} className="margin-1-b">
          {labelTranslation}
        </Label>
        <DropDownButtonVariant
          element={element}
          label={label}
          currentValue={currentValue}
          isPopupOpened={tooltipVisible}
          id={`${moduleId}_popupButton`}
          onClick={bindFunctionValue(!tooltipVisible, setTooltipVisible)}
          ref={ref}
        />
      </div>
    ) : (
      <DropdownButton
        element={element}
        label={label}
        travelers={totalTravelers}
        currentValue={currentValue}
        isPopupOpened={tooltipVisible}
        id={`${moduleId}_popupButton`}
        onClick={bindFunctionValue(!tooltipVisible, setTooltipVisible)}
        ref={ref}
      />
    )
  );
});

TravelersRoomButton.displayName = 'TravelersRoomButton';

export default TravelersRoomButton;
